import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './App.vue'

Vue.config.productionTip = false;
Vue.use(Vuelidate);

var appElem = document.getElementById('app');

new Vue({
  render: h => h(App, {
	props: {
		modelId: appElem.getAttribute('data-modelId')
	}
  }),
}).$mount('#app')
